import React from "react";
import Modal from "react-bootstrap/Modal";
import Button from 'react-bootstrap/Button';
import Card from 'react-bootstrap/Card';
import BootstrapTable from 'react-bootstrap-table-next';
import paginationFactory from "react-bootstrap-table2-paginator";

const DetalleCarga = (props) => {
    
    // Con la sintaxis de desestructuración podemos extraer valores de propiedades en objetos 
    const { data } = props;
    const { erroresCarga, erroresProceso } = data;

    return (
        <Modal {...props} size="xl" aria-labelledby="contained-modal-title-vcenter" centered>
            <Modal.Body>
                <div className="bg-secondary text-light rounded">
                    <h5 className="text-center p-2">{`Errores Archivo ID: ${data.id} - Nombre: ${data.nombreArchivo} - Fecha Carga: ${data.fechaCargaFormato}`}</h5>
                </div>
                { erroresProceso && erroresProceso.length > 0 ? 
                <Card className="mt-4 mb-4">
                    <Card.Header as="h5">Errores Genéricos</Card.Header>
                    <Card.Body>
                        <BootstrapTable bootstrap4 keyField="linea" class="table-responsive-sm" headerWrapperClasses="table-secondary" 
                            data={ erroresProceso } 
                            columns={[
                                { dataField: 'msgError', text: 'Descripción Error' }
                            ]} />
                    </Card.Body>
                </Card>
                : null }
                { erroresCarga && erroresCarga.length > 0 ? 
                <Card className="mt-4 mb-2">
                    <Card.Header as="h5">Errores de Formato y Negocio</Card.Header>
                    <Card.Body>
                        <BootstrapTable bootstrap4 condensed keyField="linea" class="table-responsive-sm" headerWrapperClasses="table-secondary" 
                            pagination={ paginationFactory({ sizePerPage: 5 }) } 
                            data={ erroresCarga } 
                            columns={[
                                { dataField: 'linea', text: 'Fila', headerStyle: { width: '5%' } },
                                { dataField: 'columna', text: 'Columna' },
                                { dataField: 'valorColumna', text: 'Valor Columna' },
                                { dataField: 'msgError', text: 'Descripción Error' }
                            ]} />
                    </Card.Body>
                </Card>
                : null }
            </Modal.Body>
            <Modal.Footer>
                <Button onClick={props.onHide}>Cerrar</Button>
            </Modal.Footer>
        </Modal>
    );
}

export default DetalleCarga;